export interface IOverlayModalStatus {
    showLoading: boolean;
    showError: boolean;
    errorData: IErrorData[]
}

export interface IErrorData {
    code: string;
    reason: string;
    uuid: null;
    timeStamp: string;
}

export interface IDownloadPDF {
    loading: boolean;
    documents: IDocs[];
    error: boolean;
}

export interface ILoadingPDF {
    loading: boolean;
    error: boolean;
}

interface IDocs {
    base64Bytes: string;
    fileName: string;
}

export enum DownloadTypeEnum {
    DESKTOP = 'DESKTOP',
    MOBILE = 'MOBILE'
}

export interface IHttpDMResponse {
    flight: IFlight;
    documents: IDocument[];
}

export interface IDigitalMenuRequest {
    flight: IDigitalMenuRequestFlight;
}
export interface IDigitalMenuDownloadRequest extends IDigitalMenuRequest {
    type?: DownloadTypeEnum
}

export interface IDigitalMenuRequestFlight {
    company: string;
    number: string;
    departureDate: string;
    cabin: string;
}


export interface IDocument {
    fileName: string;
    base64Bytes: string;
}

interface IFlight {
    company: string;
    number: string;
    departureDate: IArrivalDateClass;
    arrivalDate: IArrivalDateClass;
    departureAirport: IAirport;
    arrivalAirport: IAirport;
}

export interface IAirport {
    airportCode: string;
    airportName: string;
    cityCode: string;
    cityName: string;
    terminal: string;
}

interface IArrivalDateClass {
    date: Date;
    time: string;
    dayOfWeek: string;
}

export interface IDigitalMenuData {
    flight: IFlight;
    cabins: Cabin[];
    disclaimer: string;
    expressMenu: string | undefined;
}

interface Cabin {
    cabin: string;
    categories: ICategory[];
}

export interface ICategory {
    code: string;
    name: string;
    subtitle: null | string;
    menu: IMenu[];
    images: Image[];
}

interface Image {
    imagePath: string;
    resolution: string;
}

export interface IMenu {
    service: string;
    name: string;
    subtitle: null | string;
    items: Item[];
}

export interface Item {
    inventoryKey: null | string;
    name: string;
    description: string[];
    nationality: null;
    allergens: IAllergen[];
    image: null | string;
    images: Image[] | null;
}

interface IAllergen {
    code: string;
    name: string;
}

export interface ITabsModel {
    generals: ICategory[];
    others: ICategory[];
}
